import React from 'react';
import { connect } from 'react-redux'
import VistaCliente from './VistaCliente';

//Importación de actions.
import {
    getScreenData,
    selectTab,
    openModalInfoCliente,
    closeModalInfoCliente,
    openModalConfirmador,
    closeModalConfirmador,
    closeModalMsgConfirmador,
    getDataCliente,
    routeToRequest,    
    openModalDistribucionLimites,
    closeModalDistribucionLimites,
    resetStateVistaCliente,
    actualizarLimites,
    openPanelSeleccion,
    redirectToNuevaSolicitudCuenta,
    resetNuevaSolicitudCuenta,
    cambiarEstadoSolicitud,
    nuevaSolicitudAdicional,
    redirectToEmpresa,
    eliminarCuenta,
    AbrirModuloConsultaOperacionCuenta,
    seleccionarComponente,
    darDeBajaCuenta,
    redirectToAvisoViaje 
} from '../actions/VistaClienteActions';

import {loadModificacionSolicitud} from '../../NuevaSolicitudCuenta/actions/NuevaSolicitudCuentaActions';

import {modalViajes} from '../../AvisoViaje/actions/Actions';

const mapStateToProps = (state) => {
    return {
        data: state.vistaCliente.data,
        tarjetas: state.tarjetas
    }
}

const mapDispatchToProps = (dispatch, ownProps) => {
    return {
        getScreenData: (currentScope) => {
            dispatch(getScreenData(currentScope));
        },
        loadModificacionSolicitud: (solicitud) => {
            dispatch(loadModificacionSolicitud(solicitud));
        },
        resetNuevaSolicitudCuenta: () => {
            dispatch(resetNuevaSolicitudCuenta());
        },
        selectTab: (id) => {
            dispatch(selectTab(id));
        },
        openModalInfoCliente: () => {
            dispatch(openModalInfoCliente());
        },
        closeModalInfoCliente: () => {
            dispatch(closeModalInfoCliente());
        },
        closeModalMsgConfirmador: () => {
            dispatch(closeModalMsgConfirmador());
        },
        openModalConfirmador: (solicitudId) => {
            dispatch(openModalConfirmador(solicitudId));
        },
        closeModalConfirmador: () => {
            dispatch(closeModalConfirmador());
        },
        getDataCliente: () => {
            dispatch(getDataCliente());
        },
        routeToRequest: (requestId, borradorId, estado) => {
            dispatch(routeToRequest(requestId, borradorId, estado));
        },
        openModalDistribucionLimites: () => {
            dispatch(openModalDistribucionLimites());
        },
        closeModalDistribucionLimites: () => {
            dispatch(closeModalDistribucionLimites());
        },
        resetStateVistaCliente: () => {
            dispatch(resetStateVistaCliente());
        },
        actualizarLimites: (estado) => {
            dispatch(actualizarLimites(estado));
        },
        openPanelSeleccion: (entidadTipo, id) => {
            dispatch(openPanelSeleccion(entidadTipo, id));
        },
        redirectToNuevaSolicitudCuenta: () => {
            dispatch(redirectToNuevaSolicitudCuenta());
        },
        redirectToEmpresa: () => {
            dispatch(redirectToEmpresa());
        },
        cambiarEstadoSolicitud: (IdSolicitud,nuevoEstadoId) => {
            dispatch(cambiarEstadoSolicitud(IdSolicitud,nuevoEstadoId));
        },
        nuevaSolicitudAdicional: (infoCuenta) => {
            dispatch(nuevaSolicitudAdicional(infoCuenta));
        },
        eliminarCuenta: (infoCuenta) => {
            dispatch(eliminarCuenta(infoCuenta));
        },
        AbrirModuloConsultaOperacionCuenta: (infoCuenta) => {
            dispatch(AbrirModuloConsultaOperacionCuenta(infoCuenta));
        },
        seleccionarComponente:(componenteId,infoCuenta) => {
            dispatch(seleccionarComponente (componenteId,infoCuenta));
        },
        darDeBajaCuenta:(cuenta) => {
            dispatch(darDeBajaCuenta (cuenta));
        },
        redirectToAvisoViaje:() => {
            dispatch(redirectToAvisoViaje ());
        }
    }
}

//Connect entre el componente y las props y actions.
const VistaClienteContainer = connect(mapStateToProps, mapDispatchToProps)(VistaCliente);

export default VistaClienteContainer;